export const CONTACT = {
  PHONE: '+1-855-245-0470',
  REQUEST_RETURN_PHONE: '+1-866-684-1172',
};
